import React from "react";
import { RotateCcw } from "lucide-react";
import { useContent } from "../../context/ContentContext";
import { P_LOGO_URL } from "../../lib/api";

const T = {
  pt: {
    title: "Não foi possível carregar",
    text: "Verifica a tua ligação à internet. Se usares VPN ou bloqueador de anúncios, experimenta desativá-lo neste site.",
    retry: "Tentar novamente",
  },
  en: {
    title: "Could not load",
    text: "Check your internet connection. If you use a VPN or ad blocker, try disabling it on this site.",
    retry: "Try again",
  },
};

export default function ContentError({ onRetry }) {
  const { locale } = useContent();
  const t = T[locale] || T.pt;
  return (
    <div data-testid="content-error" className="min-h-screen flex items-center justify-center bg-peca-black px-5">
      <div className="flex flex-col items-center gap-5 text-center max-w-md">
        <img src={P_LOGO_URL} alt="Peça" className="w-16 h-16" />
        <h1 className="font-display font-extrabold uppercase text-2xl md:text-3xl text-peca-cream">{t.title}</h1>
        <p className="text-peca-grey text-sm md:text-base leading-relaxed">{t.text}</p>
        <button
          onClick={onRetry}
          data-testid="content-error-retry"
          className="inline-flex items-center gap-2 bg-peca-yellow text-peca-black font-display font-bold uppercase text-xs tracking-wide px-6 py-3 hover:bg-peca-cream transition-colors duration-200"
        >
          <RotateCcw size={14} /> {t.retry}
        </button>
      </div>
    </div>
  );
}
